import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Mail, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import Header from '@/components/layout/Header';
import FooterNew from '@/components/layout/FooterNew';
import { API, toast } from '@/App';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success('Email de réinitialisation envoyé! Vérifiez votre boîte mail.');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur lors de l\'envoi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <div className="flex-1 flex items-center justify-center py-20 bg-gray-50">
        <div className="max-w-md w-full px-4">
          <Card>
            <CardHeader>
              <CardTitle className="text-2xl text-center">Mot de passe oublié</CardTitle>
              <CardDescription className="text-center">
                {sent 
                  ? "Un email vous a été envoyé avec les instructions"
                  : "Entrez votre email pour recevoir un lien de réinitialisation"
                }
              </CardDescription>
            </CardHeader>
            <CardContent>
              {!sent ? (
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <Label htmlFor="email">Adresse email</Label>
                    <Input
                      id="email"
                      type="email"
                      placeholder="votre@email.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="flex flex-col gap-3">
                    <Button
                      type="submit"
                      className="w-full bg-cyan-500 hover:bg-cyan-600"
                      disabled={loading}
                    >
                      <Mail className="w-4 h-4 mr-2" />
                      {loading ? 'Envoi en cours...' : 'Envoyer le lien'}
                    </Button>

                    <Button
                      type="button"
                      variant="outline"
                      onClick={() => navigate('/')}
                    >
                      <ArrowLeft className="w-4 h-4 mr-2" />
                      Retour à la connexion
                    </Button>
                  </div>
                </form>
              ) : (
                <div className="space-y-4">
                  <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
                    <p className="text-sm text-green-800">
                      Un email contenant un lien de réinitialisation a été envoyé à <strong>{email}</strong>.
                      Veuillez vérifier votre boîte de réception et suivre les instructions.
                    </p>
                  </div>

                  <Button
                    variant="outline"
                    onClick={() => navigate('/')}
                    className="w-full"
                  >
                    <ArrowLeft className="w-4 h-4 mr-2" />
                    Retour à la connexion
                  </Button>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </div>

      <FooterNew />
    </div>
  );
};

export default ForgotPassword;